import script from "./DialogWithList.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogWithList.vue?vue&type=script&setup=true&lang=ts"

import "./DialogWithList.vue?vue&type=style&index=0&id=a344f980&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a344f980"]])

export default __exports__